import CurrencyChangeHandler from './currencyChange';
import CurrencyResetHandler from './currencyReset';
import IdleHandler from './idle';
import InitHandler from './init';
import PriceChangeHandler from './priceChange';

const stateHandlers = [
  InitHandler,
  IdleHandler,
  PriceChangeHandler,
  CurrencyChangeHandler,
  CurrencyResetHandler,
  {
    //Ничего не делаем, т.к. ничего не изменилось
    name: 'noop',
    matchState: (state) => {
      return (
        state.convertedPrice === state.htmlPrice &&
        state.selectedTargetCurrency === state.convertedCurrency
      );
    },
    handle: () => {},
  },
];

const getStateHandler = (elementState) => {
  const stateHandler = stateHandlers.find((state) =>
    state.matchState(elementState)
  );
  return stateHandler;
};

export default getStateHandler;
